import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function TermsOfServicePage() {
  const lastUpdated = 'September 21, 2026';
  return <div className="bg-viridia-black min-h-screen pt-32 pb-24" data-id="element-3108" data-mp="14xfy5t5yafw2">
      <SEOHead title="Terms of Service | Viridia Analytics" description="Terms of Service for Viridia Analytics, including website builds, hosting, and Yelp Ads Management." canonical="/terms" data-id="element-3109" data-mp="14ztwqbzuaa8d" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3110" data-mp="r62k2uqtaa8f">
        <ScrollReveal data-id="element-3111" data-mp="r4hpj54hyrak">
          <div className="text-center mb-16" data-id="element-3112" data-mp="m783lzgbgxrh">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-3113" data-mp="m89cbx9v1861">
              Terms of Service
            </h1>
            <p className="text-gray-400" data-id="element-3114" data-mp="h6briylta5az">Last Updated: {lastUpdated}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-3115" data-mp="87q9d4k94saq">
          <div className="bg-viridia-surface border border-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none" data-id="element-3116" data-mp="87gi7dnh0f3g">
            <div className="space-y-8 text-gray-300 leading-relaxed" data-id="element-3117" data-mp="7ugwmbob03b5">
              <section data-id="element-3118" data-mp="cn07h0vlwkc9">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3119" data-mp="cobbn1syru3w">
                  1. Acceptance of Terms
                </h2>
                <p data-id="element-3120" data-mp="3uywpcjcytqf7">
                  By accessing our website or engaging Viridia Analytics ("we,"
                  "our," or "us") for services, you agree to be bound by these
                  Terms of Service. If you do not agree to these terms, please
                  do not use our services or website.
                </p>
              </section>

              <section data-id="element-3121" data-mp="hks2w4vgmol7">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3122" data-mp="hljxbcdbmg9w">
                  2. Description of Services
                </h2>
                <p data-id="element-3123" data-mp="32cbzjnc51mdr">
                  Viridia Analytics provides digital marketing services,
                  including but not limited to ad campaign management (Google,
                  Meta, Yelp), marketing automation setup, CRM integration, and
                  web design/SEO services. The specific scope of services will
                  be outlined in a separate agreement or proposal provided to
                  the client, or for website builds, in Section 11.
                </p>
              </section>

              <section data-id="element-3124" data-mp="z4bopgi6fqod">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3125" data-mp="z2qpveotxlkp">
                  3. SMS/Text Messaging Terms
                </h2>
                <p className="mb-2" data-id="element-3126" data-mp="u22t0cdx6aik">
                  By opting in to receive SMS communications from us, you agree
                  to the following:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-3127" data-mp="k6rkibt3tzj9">
                  <li data-id="element-3128" data-mp="g5662m0x9d6y">
                    By providing your phone number and submitting a form or
                    booking request, you consent to receive automated SMS/text
                    messages from Viridia Analytics.
                  </li>
                  <li data-id="element-3129" data-mp="2agktgw6gn0jj">
                    Messages may include appointment confirmations, reminders,
                    follow-ups, service updates, and promotional content.
                  </li>
                  <li data-id="element-3130" data-mp="17wjx0cbsfoy">
                    Message frequency varies. Message and data rates may apply.
                  </li>
                  <li data-id="element-3131" data-mp="a22va0ipnv90">
                    You may opt out at any time by replying{' '}
                    <strong data-id="element-3132" data-mp="39hfyke6hyl80">STOP</strong>. Reply <strong data-id="element-3133" data-mp="39hzl6873dxsd">HELP</strong> for help.
                  </li>
                  <li data-id="element-3134" data-mp="3egj5k461f1im">
                    Opting out of SMS does not cancel any service agreement you
                    may have with us.
                  </li>
                  <li data-id="element-3135" data-mp="3igkzfr5j6qnc">
                    We are not responsible for charges from your mobile carrier.
                  </li>
                  <li data-id="element-3136" data-mp="3neuum1r99r8y">
                    SMS consent is not required as a condition of purchasing any
                    service.
                  </li>
                  <li data-id="element-3137" data-mp="12poxb4cairtr">
                    Carriers are not liable for delayed or undelivered messages.
                  </li>
                </ul>
              </section>

              <section data-id="element-3138" data-mp="wb9l1niwnfcp">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3139" data-mp="wc1il3w2bn5m">
                  4. Client Responsibilities
                </h2>
                <p className="mb-2" data-id="element-3140" data-mp="1a8ep5hz2645b">
                  To ensure the successful delivery of our services, you agree
                  to:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-3141" data-mp="1k7ng01ymn2ng">
                  <li data-id="element-3142" data-mp="1f9lvdcljyv9v">
                    Provide timely access to necessary accounts, assets, and
                    information required for campaign execution.
                  </li>
                  <li data-id="element-3143" data-mp="1u0b8wlmhkmgw">
                    Ensure that any materials provided to us do not infringe on
                    third-party intellectual property rights.
                  </li>
                  <li data-id="element-3144" data-mp="22x3tdpveupla">
                    Comply with the terms and policies of third-party
                    advertising platforms (e.g., Google, Meta, Yelp).
                  </li>
                  <li data-id="element-3145" data-mp="2hmoovahy9hdh">
                    Approve campaigns or materials in a timely manner when
                    requested.
                  </li>
                </ul>
              </section>

              <section data-id="element-3146" data-mp="28knqubew6rar">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3147" data-mp="28njpy32h7m0s">
                  5. Payment Terms
                </h2>
                <p data-id="element-3148" data-mp="1yvnp4k909hsv">
                  Fees for our services are outlined in your specific service
                  agreement. Unless otherwise stated, invoices are due upon
                  receipt. We reserve the right to pause or suspend services if
                  payment is not received within the agreed-upon timeframe. Ad
                  spend (payments made directly to platforms like Google or
                  Meta) is separate from our management fees and is the sole
                  responsibility of the client. Yelp Ads Management is billed
                  differently; see Section 10. Website builds and hosting are
                  covered in Section 11.
                </p>
              </section>

              <section data-id="element-3149" data-mp="3ht0s3ik6t2mg">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3150" data-mp="3hsr23uz56vgr">
                  6. Intellectual Property
                </h2>
                <p data-id="element-3151" data-mp="38tdtf4iueax3">
                  Upon full payment for services rendered, clients retain
                  ownership of the final deliverables (e.g., website design, ad
                  copy) created specifically for them. Viridia Analytics retains
                  ownership of any proprietary tools, methodologies, or
                  pre-existing materials used in the delivery of services.
                </p>
              </section>

              <section data-id="element-3152" data-mp="3rj3jxffkoaj7">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3153" data-mp="3rjlmsuwqpn03">
                  7. Limitation of Liability
                </h2>
                <p data-id="element-3154" data-mp="2g4zsoh0dd0hu">
                  While we strive to deliver the best possible results, Viridia
                  Analytics does not guarantee specific outcomes, such as a
                  certain number of leads or revenue, as these depend on various
                  market factors. In no event shall Viridia Analytics be liable
                  for any indirect, incidental, special, or consequential
                  damages arising out of or in connection with our services.
                  Our total liability for any claim is limited to the amount
                  you paid us for the service in question in the 12 months
                  before the claim.
                </p>
              </section>

              <section data-id="element-3155" data-mp="1ob3and19emvx">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3156" data-mp="1obutdn9rcq4s">
                  8. Termination
                </h2>
                <p data-id="element-3157" data-mp="1sau63u1qdr6s">
                  Either party may terminate the service agreement with written
                  notice as specified in the individual contract. Upon
                  termination, the client is responsible for payment for all
                  services rendered up to the termination date.
                </p>
              </section>

              <section data-id="element-3158" data-mp="367wv0b99kba0">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3159" data-mp="368gbron6gtmg">
                  9. Governing Law
                </h2>
                <p data-id="element-3160" data-mp="3k27d49qr9773">
                  These Terms of Service shall be governed by and construed in
                  accordance with the laws of the State of Arizona, without
                  regard to its conflict of law provisions. Any legal action or
                  proceeding arising under these terms shall be brought
                  exclusively in the courts located in Phoenix, Arizona.
                </p>
              </section>

              <section id="yelp-ads-management" data-id="element-3161" data-mp="2waiop4h212vf">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3162" data-mp="2wcwlbhrdun53">
                  10. Yelp Ads Management
                </h2>
                <p className="mb-2" data-id="element-3163" data-mp="bkt9urgcph2q">
                  This section covers the Yelp Ads Management service specifically. It
                  supplements, and does not replace, the general terms above.
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-3164" data-mp="o4867nk6me3j">
                  <li data-id="element-3165" data-mp="a3dwn1lee73a">
                    Month to month. Either party may cancel with 30 days' written
                    notice; the current prepaid month runs to its end and the
                    management fee is not refunded.
                  </li>
                  <li data-id="element-3166" data-mp="12sl62vme4h3b">
                    The management fee is 15% of your monthly Yelp advertising budget,
                    with a $200 a month minimum per Yelp page. Budget above $5,000 a
                    month is billed at 10% on the amount over $5,000.
                  </li>
                  <li data-id="element-3167" data-mp="y01shynpdlyi">
                    Billed in advance. On the 1st of each month we charge the payment
                    method on file for the coming month's Yelp advertising budget you
                    have set, plus the management fee. When you start mid-month, the
                    remainder of that month is prorated and charged on your start date.
                  </li>
                  <li data-id="element-3168" data-mp="1xf3sxd8htt8r">
                    Your advertising runs under Viridia's Yelp partner billing. We pass
                    Yelp's charges through at cost and never spend past the budget you
                    set. If Yelp delivers less than your set budget in a month by more
                    than $50, the difference is credited on your next charge. Credits
                    from Yelp partner promotions apply to your advertising budget and
                    appear on your statement.
                  </li>
                  <li data-id="element-3169" data-mp="10rgytlyw6myh">
                    Budget changes take effect on the next billing date. A declined
                    charge pauses your advertising until it clears; nothing runs on
                    credit.
                  </li>
                  <li data-id="element-3170" data-mp="vqjlpnsqoj3u">
                    Minimum advertising budget $1,000 a month per Yelp page. Accounts
                    under that are not accepted.
                  </li>
                  <li data-id="element-3171" data-mp="c6ufd8ttcz5a">
                    Your Yelp business page remains yours. We never submit forms or
                    messages as you.
                  </li>
                </ul>
              </section>

              <section id="websites" data-id="element-3172" data-mp="h4438k1k12r0">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3173" data-mp="h32oa4hf3w40">
                  11. Website Builds and Hosting
                </h2>
                <p className="mb-4" data-id="element-3174" data-mp="v1slrl85fxsw">
                  This section covers website builds (Starter, Growth, and
                  Premium) and Website Hosting &amp; Care. It supplements, and
                  does not replace, the general terms above. By paying for a
                  website build you agree to this section.
                </p>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3175" data-mp="1dtli9pmfg15d">
                  Free sample
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3176" data-mp="19u2u8kzb79yb">
                  <li data-id="element-3177" data-mp="1gwhvh3xmbuzx">
                    The sample we build before you buy is free, and you owe
                    nothing if you pass. The sample stays ours until you pay.
                    Samples may use licensed stock photos.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3178" data-mp="1vkvut4vtt1bq">
                  What each build includes
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3179" data-mp="1zn8yzouxcr6e">
                  <li data-id="element-3180" data-mp="24lkas54s5br9">
                    <strong data-id="element-3181" data-mp="24l10naldfrns">Starter ($500 one-time):</strong> up to 4 pages,
                    tap-to-call and tap-to-text buttons, basic on-page SEO, a
                    sitemap, and Google Search Console setup. No contact form.
                  </li>
                  <li data-id="element-3182" data-mp="2ehnlw0hm0kqc">
                    <strong data-id="element-3183" data-mp="f6m9kjmvrsp4">Growth ($850 one-time):</strong> up to 5 pages, a
                    quote/contact form that sends leads to your phone or email,
                    Privacy Policy and Terms pages, and schema markup.
                  </li>
                  <li data-id="element-3184" data-mp="2xgs3ia1gh1e7">
                    <strong data-id="element-3185" data-mp="2xi3b6ky0utal">Premium ($1,200+ one-time):</strong> 7 or more
                    pages and a business email on your domain. Final scope and
                    price are confirmed in writing before we start.
                  </li>
                  <li data-id="element-3186" data-mp="2jp3s68z16gya">
                    Anything not listed for your tier (extra pages, forms,
                    booking tools, e-commerce, logo design, integrations) is
                    quoted separately before we do it.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3187" data-mp="37e6azk5eifud">
                  Timeline and your part
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3188" data-mp="32fuzl4zgjxa1">
                  <li data-id="element-3189" data-mp="1vyzroah52xbi">
                    We aim to have your site live within 2 to 3 business days
                    after payment and after we have what we need from you
                    (business details, license number, service area, services,
                    photos, and a logo if you have one), usually sent through
                    our onboarding form. Delays in getting us that information
                    move the date.
                  </li>
                  <li data-id="element-3190" data-mp="35xr5jmvmqop0">
                    You confirm that everything you give us (license numbers,
                    service claims, photos, logos, reviews) is accurate and that
                    you have the right to use it. You are responsible for the
                    accuracy of licensing and service claims shown on your site.
                  </li>
                  <li data-id="element-3191" data-mp="3on76ucf52l6h">
                    If we do not hear back from you for 30 days while waiting
                    on information or approval, we may launch the site with what
                    we have and treat the build as delivered.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3192" data-mp="2i6v7i80kyx9b">
                  Photos
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3193" data-mp="2alrmxs6luktd">
                  <li data-id="element-3194" data-mp="25nq3h659ojhd">
                    Your own job photos work best. Until you send enough of
                    them, we use licensed stock images that do not show
                    identifiable people, and we never present stock images as
                    your completed work.
                  </li>
                  <li data-id="element-3195" data-mp="1qybsxupyfw0e">
                    We swap in the photos you send before launch or during your
                    tweak round. Photo swaps after that are handled like other
                    changes.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3196" data-mp="20py1fjawrgzg">
                  Changes and revisions
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3197" data-mp="188c51b5uomyk">
                  <li data-id="element-3198" data-mp="186j1i4qjaius">
                    Your build includes one round of small tweaks (colors,
                    wording, photos, section order), requested within 14 days
                    of launch. Send all tweaks together in one message.
                  </li>
                  <li data-id="element-3199" data-mp="389jxcbh9l4qt">We do not make changes to the sample before payment.</li>
                  <li data-id="element-3200" data-mp="3d0s758mias4i">
                    Additional rounds, and anything that changes scope (more
                    pages, a form, new sections, a redesign), are quoted before
                    we start or handled by upgrading to the next tier.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3201" data-mp="2pb7kaen8fapy">
                  Payment and refunds
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3202" data-mp="2ua10ietwlftt">
                  <li data-id="element-3203" data-mp="2yc5trcgfwafx">
                    Build fees are paid in full up front. Because you see and
                    approve a sample before paying, build fees are
                    non-refundable once work on your final site begins.
                  </li>
                  <li data-id="element-3204" data-mp="do9lkeqcn8v8">
                    If we cannot deliver your site, you get a full refund of the
                    build fee.
                  </li>
                  <li data-id="element-3205" data-mp="1u3ou5xwddegm">
                    If you have a problem with a charge, contact us first at
                    (623) 300-0708 and we will work it out. We may pause your
                    site while a payment dispute or chargeback is open.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3206" data-mp="1fdzp3rl5oqb2">
                  Website Hosting &amp; Care ($20 a month)
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3207" data-mp="1agr7bs3x6oac">
                  <li data-id="element-3208" data-mp="16duivkrp7xyh">
                    Hosting covers hosting, SSL, domain management, and keeping
                    the site online. It is required to keep your site live on
                    our platform.
                  </li>
                  <li data-id="element-3209" data-mp="30oq2rj8c2zgk">
                    Starter and Growth include the first month of hosting free;
                    Premium includes the first three months free. After that,
                    hosting renews automatically at $20 a month on the card you
                    paid with until you cancel.
                  </li>
                  <li data-id="element-3210" data-mp="1uxc30s9k383v">
                    Cancel anytime by email or text before your next billing
                    date. There are no partial-month refunds; your site stays
                    live through the end of the paid period and then goes
                    offline.
                  </li>
                  <li data-id="element-3211" data-mp="1py8zxdd4zbyj">
                    If a hosting payment fails and is not fixed within 14 days,
                    we may take the site offline until it is.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3212" data-mp="1gw9hcgmh3zth">
                  Your domain
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3213" data-mp="36ciljzpzumlo">
                  <li data-id="element-3214" data-mp="3bblq7j22aqt4">
                    If you already own a domain, it stays in your own account
                    and we connect it to your site at no charge. The transfer
                    fee below does not apply to a domain you own.
                  </li>
                  <li data-id="element-3215" data-mp="umsxouy45oet">
                    If you do not have one, your domain name is included free.
                    We register it in our registrar account and renew it for you
                    while your hosting is active.
                  </li>
                  <li data-id="element-3216" data-mp="1icwzqxvnlg3p">
                    You can move a domain we registered for you to your own
                    registrar account at any time for a one-time $99 transfer
                    fee.
                  </li>
                  <li data-id="element-3217" data-mp="1sbmh8pjn0yjf">
                    If you cancel hosting, we hold a domain we registered for
                    you for 30 days so you can transfer it. After that it may be
                    allowed to expire.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3218" data-mp="3p5ppbdvvzshm">
                  Your information
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3219" data-mp="1m2sk6wxuj3u0">
                  <li data-id="element-3220" data-mp="1h6ah01i5zdjs">
                    We collect the details you give us at checkout and in our
                    onboarding form (your name, business name, address, phone,
                    email, services, service area, logo, and photos) to build
                    and run your site.
                  </li>
                  <li data-id="element-3221" data-mp="136iybngpd8zg">
                    We also use your contact details for essential
                    communications about your project and account, such as build
                    updates, invoices, payment and hosting notices, and service
                    changes. These are part of the service and are not marketing.
                  </li>
                  <li data-id="element-3222" data-mp="2oiu46y2q2ozn">
                    Business details you ask us to show (like your phone,
                    service area, or address) will appear publicly on your site.
                    Marketing messages are separate and you can opt out of them
                    at any time. See our Privacy Policy for more.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3223" data-mp="2w0ij11owz4qu">
                  Ownership
                </h3>
                <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-3224" data-mp="2m4fjm3lg5k7l">
                  <li data-id="element-3225" data-mp="2m4xlbfqvoqmw">
                    Once your build is paid in full, the content and design made
                    for you are yours, as described in Section 6. The platforms,
                    templates, stock images, and tools we use to build and host
                    it stay ours or our providers'.
                  </li>
                  <li data-id="element-3226" data-mp="3539v93pm64jj">
                    We may show your site in our portfolio. Tell us if you would
                    rather we did not.
                  </li>
                </ul>
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-3227" data-mp="3sr17y8f2gjlc">
                  No guarantees on results
                </h3>
                <ul className="list-disc pl-6 space-y-2" data-id="element-3228" data-mp="bagkujypmxdt">
                  <li data-id="element-3229" data-mp="b7ue2mjn8lwn">
                    We build your site so Google and AI search can read it, but
                    we do not guarantee rankings, traffic, calls, leads, or
                    revenue. Search engines and other third-party services are
                    outside our control.
                  </li>
                </ul>
              </section>

              <section data-id="element-3230" data-mp="3ohi81n2zlg4c">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-3231" data-mp="3oitg3z3gta19">
                  12. Contact Information
                </h2>
                <p className="mb-2" data-id="element-3232" data-mp="3fo57q02lfc88">
                  If you have any questions about these Terms of Service, please
                  contact us:
                </p>
                <ul className="list-none space-y-1" data-id="element-3233" data-mp="3an7ix4n2vjxr">
                  <li data-id="element-3234" data-mp="35p5yogdx1ekp">
                    <strong data-id="element-3235" data-mp="35ppiy3r1gf1w">Company:</strong> Viridia Analytics LLC
                  </li>
                  <li data-id="element-3236" data-mp="30sfhtquaeey8">
                    <strong data-id="element-3237" data-mp="30t7gjaj6kssq">Address:</strong> 19025 N. 31st Pl., Phoenix, AZ 85050
                  </li>
                  <li data-id="element-3238" data-mp="2qpa7b1pwidnn">
                    <strong data-id="element-3239" data-mp="2vm0ndp1ph992">Email:</strong>{' '}
                    <a href="mailto:info@viridiaanalytics.com" className="text-viridia hover:underline" data-id="element-3240" data-mp="2vkzf1sc2r0v1">
                      info@viridiaanalytics.com
                    </a>
                  </li>
                  <li data-id="element-3241" data-mp="27x7ygcji41ny">
                    <strong data-id="element-3242" data-mp="27xra5bik5ttj">Phone:</strong>{' '}
                    <a href="tel:6233000708" className="text-viridia hover:underline" data-id="element-3243" data-mp="27uvbfkyvz141">
                      (623) 300-0708
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>;
}